import { render, staticRenderFns } from "./AppModules.vue?vue&type=template&id=c8dd5060&scoped=true&"
import script from "./AppModules.vue?vue&type=script&lang=js&"
export * from "./AppModules.vue?vue&type=script&lang=js&"
import style0 from "./AppModules.vue?vue&type=style&index=0&id=c8dd5060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dd5060",
  null
  
)

export default component.exports